export default __webpack_public_path__ + "static/media/teakleaves.7b37782c.gif";